import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { spacing16, spacing24 } from 'approot/shared/styles/spacing.style';
import { Draw } from '../draw/canvas/draw.style';
import {
  borderRadius8,
  boxShadow815Grey,
} from 'approot/shared/styles/borders.style';
import { grey1, grey5 } from 'approot/shared/styles/colours.style';
import { ACTIVITY_SHEET_CONTENT_MAX_WIDTH } from '../shared/sheet/activity-sheet.style';

export const DiscussionWrapper = styled.div`
  height: 100%;
  display: flex;
`;
export const DiscussionWrapperInner = styled.div`
  margin: auto;
  max-width: ${rem(ACTIVITY_SHEET_CONTENT_MAX_WIDTH)};
  padding: 0 ${rem(spacing24)};
  width: 100%;
`;

export const DiscussionDrawWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  flex-grow: 1;
  height: 100%;

  /* Draw canvas overrides */
  ${Draw} {
    height: 100%;
  }
`;

export const DiscussionShowInstruction = styled.div`
  ${boxShadow815Grey}
  background-color: ${grey1};
  border-radius: ${rem(borderRadius8)};
  border: 1px solid ${grey5};
  margin: ${rem(spacing16)};
  max-width: ${rem(200)};
  padding: ${rem(spacing16)};
  position: relative;
  z-index: 1;
`;
